import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../core/guards/auth.guard';
import { MyDocumentsComponent } from './my-documents/my-documents.component';
import { MyDocumentsResolverService } from '../create-message/my-documents-resolver.service';


const routes: Routes = [
    {
        path: 'moja-biblioteka',
        canActivate: [
            AuthGuard
        ],
        children: [
            {
                path: '',
                component: MyDocumentsComponent,
                data: {
                    pageTitle: 'Moja biblioteka'
                },
                resolve: {
                    myDocuments: MyDocumentsResolverService
                }
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MyDocumentsRoutingModule { }
